import type EmailRemindersStore from '../store/schema/EmailRemindersStore';
import { getStore } from '../store/store';

export function getEmailRemindersPickerStore(viewStateId: string | null): EmailRemindersStore {
    const emailRemindersPickerStore = getStore().viewStates.get(viewStateId);
    if (emailRemindersPickerStore) {
        return emailRemindersPickerStore;
    } else {
        throw new Error('Email reminders picker store missing for id: ' + viewStateId);
    }
}
